import initialState from './initial.state';
import * as types from '../actions/types.action';

export default function orderReducer(state = initialState.order, action) {
  switch (action.type) {
    case types.PLACE_BASKET_ORDER_SUCCESS:
      return action.order;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/order.reducer.js